import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import FontAwesomeIcon from 'pf9-ui-components/built/components/FontAwesomeIcon'
import SimpleLink from 'pf9-ui-components/built/components/SimpleLink'
import Card from 'pf9-ui-components/built/elements/card/Card'
import CardBody from 'pf9-ui-components/built/elements/card/CardBody'
import React from 'react'
import Button from 'core/elements/button/Button'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'

interface BusinessContinuityCardProps {
  className?: string
}

export default function BusinessContinuityCard({ className }: BusinessContinuityCardProps) {
  const classes = useStyles()
  return (
    <Card className={clsx(classes.businessContinuityCard, className)} withCustomBody>
      <CardBody className={classes.businessContinuityCardBody}>
        <div className={classes.businessContinuityCardHeader}>
          <Text variant="subtitle1">Business Continuity</Text>
          <SimpleLink textVariant="caption1" icon="chevron-right" onClick={null}>
            Manage Services
          </SimpleLink>
        </div>
        <div className={classes.detailsContainer}>
          <div className={clsx(classes.infoBox, classes.borderRight)}>
            <Text variant="body2">Workload HA</Text>
            <div className={classes.statusRow}>
              <FontAwesomeIcon solid className={classes.check}>
                circle-check
              </FontAwesomeIcon>
              <Text variant="body2" className={classes.passiveText}>
                All Protected
              </Text>
            </div>
          </div>
          <div className={clsx(classes.infoBox, classes.borderRight)}>
            <Text variant="body2">Backup Policy</Text>
            <Text variant="subtitle2">Implemented, Compliant</Text>
          </div>
          <div className={clsx(classes.infoBox, classes.borderRight)}>
            <Text variant="body2">DR Protection</Text>
            <div className={classes.statusRow}>
              <FontAwesomeIcon solid className={classes.triangleExclamation}>
                circle-check
              </FontAwesomeIcon>
              <Text variant="body2" className={classes.passiveText}>
                Not Found
              </Text>
            </div>
          </div>
          <div className={classes.infoBox}>
            <Text variant="body2">Security Patches</Text>
            <div className={classes.statusRow}>
              <FontAwesomeIcon solid className={classes.circleExclamation}>
                circle-check
              </FontAwesomeIcon>
              <Text variant="body2" className={classes.passiveText}>
                Not Patched
              </Text>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  )
}

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  businessContinuityCardBody: {
    display: 'grid',
    gridTemplateRows: 'auto max-content',
    gap: theme.spacing(2),
  },
  businessContinuityCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
  },
  arrow: {
    fontSize: 12,
  },
  detailsContainer: {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto auto',
    gap: theme.spacing(2),
  },
  infoBox: {
    display: 'grid',
    gap: theme.spacing(1),
    padding: theme.spacing(0, 2),
    marginBottom: theme.spacing(1),
  },
  borderRight: {
    borderRight: `1px solid ${theme.palette.grey[300]}`,
  },
  statusRow: {
    display: 'grid',
    gridTemplateColumns: 'max-content max-content',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  check: {
    color: theme.components.badge.success.color,
  },
  circleExclamation: {
    color: theme.components.badge.error.color,
  },
  triangleExclamation: {
    color: theme.components.badge.warning.color,
  },
  passiveText: {
    color: theme.components.typography.passive,
  },
}))
